import { IconConfig } from "../types";

export const DropdownChevron:IconConfig = {
  type: 'complex' as const,
  viewBox: "0 0 24 24", // Calculé d'après les coordonnées du path
  elements: [
    {
      type: 'symbol',
      id: "dropdown",
      children: [
        {
          type: 'path',
          d: "M5.42 6.945.189 1.717a.646.646 0 0 1 0-.914l.61-.61a.646.646 0 0 1 .913 0l4.165 4.146L10.042.188a.646.646 0 0 1 .913 0l.61.61a.646.646 0 0 1 0 .914L6.334 6.945a.646.646 0 0 1-.914 0"
        }
      ]
    }
  ]
}
